import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

import {AiUsageSection} from '.';

type Props = {
    isEnabled: boolean;
    setIsEnabled: (isEnabled: boolean) => void;
    limit: number | null | undefined;
    remaining: number | null | undefined;
};

export function AiAgentSection(props: Props) {
    return (
        <StackLegacy spacing={8}>
            <Body isBold={true} color='dark' size='large'>
                Agents
            </Body>
            <AiUsageSection
                setIsEnabled={props.setIsEnabled}
                isEnabled={props.isEnabled}
                description='Enable AI agents'
                title='Agent usage'
                link='https://support.nutshell.com/en/articles/11402118-ai-ai-agents'
                limit={props.limit}
                remaining={props.remaining}
                unit={props.remaining === 1 ? 'conversation' : 'conversations'}
            />
        </StackLegacy>
    );
}
